import React, { useEffect, useState } from "react";
import { Paciente, Usuario } from "../../interfaces";
import {
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonInput,
  IonItem,
  IonList,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import RtfEditor from "../RtfEditor/RtfEditor";
import StyledButton from "../StyledButton/StyledButton";
import dayjs from "dayjs";
import useNotificacion from "../../hooks/notificacion";
import axios, { AxiosResponse } from "axios";
import { useSession } from "../../hooks/SessionContext";

import http from "../../hooks/httpAdapter";
import { useHistory } from "react-router";
require("dayjs/locale/es");

interface ContainerProps {
  abrirModal: boolean;
  setAbrirModal: (abrir: boolean) => void;
}
const ModalPedido: React.FC<ContainerProps> = ({ abrirModal, setAbrirModal }) => {
  const [pedido, setPedido] = useState<string>("");

  const { pacienteCargado, hcUL, cargandoSession, setSesionInvalida, mostrarNotificacion } =
    useSession();
  const history = useHistory();

  useEffect(() => {
    setPedido(`<p>Fecha: ${dayjs().format("YYYY-MM-DD")}</p><p><br><br>
                  Paciente: ${pacienteCargado?.apellido}, ${pacienteCargado?.nombre}<br>
                  Edad: ${dayjs().diff(pacienteCargado?.nacimiento, "year")}<br>
                  Mutual: ${pacienteCargado?.mutualNombre}<br>
                  Nro. Afiliado: ${pacienteCargado?.mutualAfiliado}<br>
                  Diagnostico: <br><br><br></p>`);
  }, [pacienteCargado]);

  const handleChangeInput = (value: any, id: string) => {
    switch (id) {
      case "pedido":
        setPedido(value);
        break;
      default:
        mostrarNotificacion(true, "Cambio inválida", "rojo");
        break;
    }
  };

  const handleClickEnviar = async () => {
    let estado = 0;
    let respuesta = "";
    if (hcUL !== null) {
      if (pacienteCargado !== null && pacienteCargado.codigo !== 0) {
        try {
          let config = {
            headers: { Authorization: `Bearer ${hcUL.token}` },
          };
          const response: AxiosResponse = await http()
            .post(
              `Pedidos/EnviarPorMail`,
              {
                pedidoHTML: pedido,
                prestador: hcUL.prestadorCod,
                pacienteDoc: pacienteCargado.documentoNro,
                mail: pacienteCargado.email,
              },

              config
            )
            .catch((e) => {
              if (e.response && e.response.status === 401) {
                setSesionInvalida(true);
                // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
              } else {
                console.error(e);
              }
            });

          estado = response.status;
          respuesta = response.statusText;

          mostrarNotificacion(true, "Pedido enviado correctamente", "Verde");
          setAbrirModal(false);
        } catch (error) {
          //@ts-ignore
          mostrarNotificacion(true, "Error: " + error.response, "rojo");
        }
      } else {
        mostrarNotificacion(true, "Error: " + "No se encuentra al paciente", "rojo");
      }
    } else {
      mostrarNotificacion(true, "Error: " + "No se encuentra la sesion de usuario", "rojo");
    }
  };

  return (
    <IonModal isOpen={abrirModal} onDidDismiss={() => setAbrirModal(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Pedido</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" id="inbox-list">
        <IonList>
          <IonItem>
            <IonInput
              aria-label="Email"
              label-placement="floating"
              value={pacienteCargado?.email}
              readonly
            />
          </IonItem>
          <IonRow>
            <IonCol>
              <RtfEditor
                id="pedido"
                handleChange={handleChangeInput}
                defaultValue={pedido}
                readOnly={false}
                seeToolbar={false}
                returnHtml={false}
              />
            </IonCol>
          </IonRow>
        </IonList>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonRow className="ion-justify-content-around">
            <StyledButton
              lines="none"
              expand="block"
              className="rojo  ion-padding-horizontal"
              onClick={() => setAbrirModal(false)}
            >
              Cancelar Pedido
            </StyledButton>
            <StyledButton
              lines="none"
              expand="block"
              className="verde  ion-padding-horizontal"
              onClick={handleClickEnviar}
            >
              Enviar Pedido
            </StyledButton>
          </IonRow>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};

export default ModalPedido;
